import React, { useEffect, useRef, useState } from "react";
import GoldMedallionIcon from  "../../img/gold.svg";
import SilverOneMedallionIcon from  "../../img/silver_1.svg";
import SilverTwoMedallionIcon from  "../../img/silver_2.svg";
import BronzeMedallionIcon from  "../../img/bronze.svg";

import {
  Button,
  PageHeader,
  Form,
  Input,
  Select,
  Dropdown,
  Menu,
  message,
  Drawer,
  Space,
  Tag
} from "antd";
import {
  InfoCircleOutlined,
  UserOutlined,
  PlusOutlined,
  InfoOutlined,
  LeftCircleOutlined,
  VerticalAlignMiddleOutlined,
  UndoOutlined,
  SwapOutlined,
  FlagOutlined,
  CloseOutlined,
  DatabaseOutlined
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import GroupCodesService from "../../services/groupcodes/GroupCodesService";
import TablesService from "../../services/tables/TablesService";
import { setAccessToken, setEntity, setEntityPermissions, setGroupCode, setGroupCodePermissions, setOperation, setReport, setPermissions, setProfile, setUserPermissions } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import WikiService from "../../services/wiki/WikiService";
import tablesService from "../../services/tables/TablesService";
import { useTranslation } from "react-i18next";
import PermissionsService from "../../services/admin/PermissionsService";
import UsersService from "../../services/admin/UsersService";
import JwtService from "../../services/jwt/JwtService";
import { RefreshJwt } from "../../models/jwt/RefreshJwt";
import ApplicationService from "../../services/application/ApplicationService";
import {GLOBAL_COMPONENT, GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT} from "../../config/consts/appsettings";
import {OPERATIONS} from "../../config/constants";
import { text } from "stream/consumers";


const { Option } = Select;

const PageHead = ({
  title,
  icon,
  routes,
  groupCodes,
  entities,
  operations,
  reports,
  mainAction,
  otherActions,
  selectedGroupCode,
  selectedEntity,
  selectedOperation,
  selectedReport,
  setSelectedGroupCode,
  setSelectedEntity,
  setSelectedOperation,
  setSelectedReport,
  setSelectGroupCodeDisabled,
  setSelectEntityDisabled,
  setSelectOperationDisabled,
  setActionsDisabled,
  showBackArrow = true,
  showGroupCodes = true,
  showEntities = true,
  showOperations = true,
  showReports = false,
  softSelectedGroupCode,
  softSelectedReport,  
  showEntityCounts = false,
}: {
  title: string;
  icon: any;
  routes: Array<any>;
  groupCodes: Array<any>;
  entities: Array<any>;
  operations: Array<any>;
  reports?: Array<any>;
  mainAction: any;
  otherActions: Array<any>;
  selectedGroupCode: any;
  selectedEntity: any;
  selectedOperation: any;
  selectedReport?: any;
  setSelectedGroupCode: any;
  setSelectedEntity: any;
  setSelectedOperation: any;
  setSelectedReport?: any;
  setSelectGroupCodeDisabled: boolean;
  setSelectEntityDisabled: boolean;
  setSelectOperationDisabled: boolean;
  setActionsDisabled: boolean;
  showBackArrow?: boolean;
  showGroupCodes?: boolean;
  showEntities?: boolean;
  showOperations?: boolean;
  showReports?: boolean;
  softSelectedGroupCode?: any;
  softSelectedReport?: any;
  showEntityCounts?: boolean;
}) => {
  const {
    profile
  } = useSelector((state: any) => ({
    profile: state.profile
  }));
  
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  let location = useLocation();
  
  const groupCodeRef = useRef<any>();
  const entityRef = useRef<any>();
  const operationRef = useRef<any>();
  const reportRef = useRef<any>();

  const { t, i18n } = useTranslation("translations");

  const [showWikiDrawer, setShowWikiDrawer] = useState<boolean>(false);
  const [showWikiButton, setShowWikiButton] = useState<boolean>(false);
  const [wikiContent, setWikiContent] = useState<any>("");
  const [searchParams, setSearchParams] = useSearchParams();

  const { state }: any = useLocation();
  const [transferedState, setTransferedState] = useState(null);
  
  const [defaultGroupCode, setDefaultGroupCode] = useState<any>(undefined);
  const [headEntities, setHeadEntities] = useState<any[]>([]);
  const [entitySources, setEntitySources] = useState<any[]>([]);
  const [entitySourceCounts, setEntitySourceCounts] = useState<any[]>([]);
  const {
    groupCode,
    entity,
    operation,
    report
  } = useSelector((state: any) => ({
    groupCode: state.groupCode,
    entity: state.entity,
    operation: state.operation,
    report: state.report
  }));
  
  useEffect(() => {
    if (state) {
      setTransferedState(state);
    }
  }, [state]);

  useEffect(() => {
    if (transferedState && headEntities && headEntities.length > 0) {
      onEntityChange(headEntities.find((x:any) => x.name === transferedState.entity).id);
      onGroupCodeChange(transferedState.groupCode);
    }
  }, [transferedState, headEntities])

  useEffect(() => {
    if (!!searchParams.get("groupCode") && !!searchParams.get("entity") && headEntities && headEntities.length > 0) {
      setTransferedState({
        groupCode: searchParams.get("groupCode"),
        entity: searchParams.get("entity"),
      });
    }
  }, [searchParams, headEntities]);

  useEffect(() => {
    if (softSelectedGroupCode) {
      JwtService.refreshToken(softSelectedGroupCode, selectedEntity).then((response) => {
        dispatch(setAccessToken(response.data.token));
        dispatch(setUserPermissions(response.data.permissions));
        setSelectedGroupCode(softSelectedGroupCode);
        form.setFieldsValue({ groupCode: softSelectedGroupCode });
      }); 
    }
  }, [softSelectedGroupCode]);

  useEffect(() => {
    TablesService.getEntitySourcesCount().then((response: any) => {
      const data = response.data;
      setEntitySources(data);
    });
  }, []);

  useEffect(() => {
    if (selectedGroupCode) {
      setEntitySourceCounts(entitySources.filter(x => x.groupCode == selectedGroupCode));
    } else {
      setEntitySourceCounts(entitySources);
    }
  }, [selectedGroupCode, entitySources]);

  useEffect(() => {
    let fetchId = Date.now(); // unique id for this fetch instance
    let active = true;        // active flag for this fetch instance

    const fetchEntities = async () => {
      if (!selectedGroupCode || setSelectGroupCodeDisabled) {
        const response = await TablesService.getAllEntitiesPerGroupCode();
        if (!active) return; // If not latest, ignore
        setHeadEntities(response.data);
        form.setFieldsValue({ entity: undefined });
      } else {
        const response = await TablesService.getAllEntitiesPerGroupCode(selectedGroupCode);
        if (!active) return; // If not latest, ignore
        setHeadEntities(response.data);
        form.setFieldsValue({ entity: undefined });
      }
    };

    fetchEntities();

    // Cleanup function: mark previous fetch as inactive
    return () => {
      active = false;
    };
  }, [selectedGroupCode, selectedOperation]);

  const onGroupCodeChange = (value: string) => {
    JwtService.refreshToken(value, selectedEntity).then((response) => {
      dispatch(setAccessToken(response.data.token));
      dispatch(setUserPermissions(response.data.permissions));
      setSelectedGroupCode(value);
      dispatch(setGroupCode(value));
      form.setFieldsValue({ groupCode: value });
    });
  };
  
  const onEntityChange = (value: string) => {
    JwtService.refreshToken(selectedGroupCode, value).then((response) => {
      dispatch(setAccessToken(response.data.token));
      dispatch(setUserPermissions(response.data.permissions));
      setSelectedEntity(value);
      dispatch(setEntity(value));
      form.setFieldsValue({ entity: value });
    });
  };
  const onOperationsChange = (value: string) => {
    setSelectedOperation(value);
  };

  const onReportChange = (value: string) => {
    setSelectedReport(value);
    dispatch(setReport(value));
    form.setFieldsValue({ report: value });
  };

  useEffect(() => {
    if (!location.pathname || location.pathname === '/') {
      setShowWikiButton(false);
      return;
    }
    
    const tab = searchParams.get("tab");
    let path = "/wiki" + location.pathname;
    const languageCode = i18n.resolvedLanguage;
    if (tab) {
      path += "/" + tab;
    }
    WikiService.get(path, languageCode).then((response: any) => {
      if (response != null) {
        setShowWikiButton(true);
      }
    }).catch((error: any) => {
      console.log(error); // TODO: handle better
      setShowWikiButton(false);
    });
  }, [])

  useEffect(() => {
    dispatch(setOperation(selectedOperation));
    form.setFieldsValue({ operation: selectedOperation });
  }, [selectedOperation]);

  useEffect(() => {
    if (groupCodes.length > 0) {
      if (groupCode && groupCodes.findIndex((x: any) => x.code === groupCode) !== -1) {
        setSelectedGroupCode(groupCode);
        form.setFieldsValue({ groupCode: groupCode });
      } else {
        setSelectedGroupCode(undefined);
      }
    }
  }, [groupCodes, groupCode]);

  useEffect(() => {
    if (headEntities.length > 0 && entities.length > 0) {
      if (entity && headEntities.findIndex((x: any) => x.id === entity) !== -1) {
        setSelectedEntity(entity);
        form.setFieldsValue({ entity: entity });
      } else {
        setSelectedEntity(undefined);
      }
    }
  }, [entities, headEntities, entity]);

  useEffect(() => {
    if (operations.length > 0) {
      if (operation) {        
        setSelectedOperation(operation);
        form.setFieldsValue({ operation: operation });
      } else {
        setSelectedOperation(undefined);
      }
    }
  }, [operations, operation]);

  useEffect(() => {
    if (reports && reports.length > 0) {
      if (report) {
        setSelectedReport(report);
        form.setFieldsValue({ report: report });
      } else {
        setSelectedReport(undefined);
      }
    }
  }, [reports, report]);

  useEffect(() => {
    if (showGroupCodes && !setSelectGroupCodeDisabled && !selectedGroupCode) {
      groupCodeRef.current.focus();
      return;
    }
    if (showEntities && !setSelectEntityDisabled && !selectedEntity) {
      entityRef.current.focus();
      return;
    }
    if (showOperations && !setSelectOperationDisabled && !selectedOperation) {
      operationRef.current.focus();
      return;
    }
    
    if (showGroupCodes) {
      groupCodeRef.current.blur();  
    }
    if (showEntities) {
      entityRef.current.blur();
    }
    if (showOperations) {
      operationRef.current.blur();
    }
  }, [selectedGroupCode, selectedEntity, selectedOperation]);

  useEffect(() => {
    ApplicationService.getPreferences().then(resp => {
      UsersService.userGroups(profile.id).then((response) => {
        const userGroups = response.data;

        const existingUserPreference = resp.data.find(x =>
            x.componentName === GLOBAL_COMPONENT &&
            x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
            x.object === "User" &&
            x.objectId.toString() === profile.id.toString());

        const existingGroupPreference = resp.data.find(x =>
            x.componentName === GLOBAL_COMPONENT &&
            x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
            x.object === "UserGroup" &&
            userGroups.includes(x.objectId));

        const existingAppPreference = resp.data.find(x =>
            x.componentName === GLOBAL_COMPONENT &&
            x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
            x.object === "Application");

        if (existingUserPreference) {
          setDefaultGroupCode(existingUserPreference.value)
          return;
        }
        if (existingGroupPreference) {
          setDefaultGroupCode(existingGroupPreference.value)
          return;
        }
        if (existingAppPreference) {
          setDefaultGroupCode(existingAppPreference.value)
        }
      });
    })
  }, []);

  useEffect(() => {
    if (headEntities.length > 0) {
      const entityValue = form.getFieldValue('entity');

      const existsInOptions = headEntities.some(x => x.id === entityValue);

      if (!existsInOptions) {
        // If current form value is invalid, clear it
        form.setFieldsValue({ entity: undefined });
      }
    }
  }, [headEntities]);

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    message.info("Click on menu item.");
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    message.info("Click on left button.");
  };

  const openInfoDrawer = () => {
    const tab = searchParams.get("tab");
    let path = "/wiki" + location.pathname;
    const languageCode = i18n.resolvedLanguage;
    if (tab) {
      path += "/" + tab;
    }
    WikiService.get(path, languageCode).then((response: any) => {
      setWikiContent(response.data.content);
      setShowWikiDrawer(true);
    });
  };

  const closeDrawer = () => {
    setShowWikiDrawer(false);
    setWikiContent("");
  };

  function itemRender(route: any, params: any, routes: any, paths: any) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : route.path ? (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    ) : (
      <span>{route.breadcrumbName}</span>
    );
  }
  
  const calculateMedallionTag = (operationId: number) => {
    switch (operationId) {
      case OPERATIONS.IMPORT:
        return (
            <Tag className={"bronze-tag"}>
              <img src={BronzeMedallionIcon} alt="Medal" width={12} />
            
            </Tag>)
      
      case OPERATIONS.LEGACY:
        return (
            <Tag className={"silver-tag"}>
              <img src={SilverOneMedallionIcon} alt="Medal" width={12} />
             
            </Tag>)
      
      case OPERATIONS.VALIDATION:
        return (
            <Tag className={"silver-tag"}>
              <img src={SilverTwoMedallionIcon} alt="Medal" width={12} />
            </Tag>)
        
      case OPERATIONS.LOADFILE:
        return (
            <Tag className={"bronze-tag"}>
              <img src={GoldMedallionIcon} alt="Medal" width={12} />
              
            </Tag>)
      default:
        return (<></>)
    }
  }

  const filteredUniqueEntities = React.useMemo(() => {
    const seen = new Set<string>();
    
    return headEntities
        .filter((x) => {
          const idNameKey = `${x.id}_${x.name}`;
          if (seen.has(idNameKey)) return false;
          seen.add(idNameKey);

          if (!selectedOperation || !selectedGroupCode || setSelectGroupCodeDisabled) {
            return true;
          }
          
          return x.alwaysShow || x.groupCode === selectedGroupCode;
        });
  }, [headEntities, selectedGroupCode, selectedOperation]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          background: "var(--white)",
          padding: "10px 20px",
          borderBottom: "1px solid var(--light-grey)",
          alignItems: "center",
        }}
      >
        <div>
          <PageHeader
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "flex-end",
              alignItems: "baseline",
              padding: "0",
            }}
            className="site-page-header"
            title={
              <div>
                {icon}
                <span style={{ paddingLeft: "6px" }}>{title}</span>
              </div>
            }
            breadcrumb={{ routes, itemRender }}
            onBack={() => window.history.back()}
          />
        </div>
        <div style={{ display: showWikiButton ? "flex" : "none", alignItems: "center" }}>
          <Button
            key="1"
            type="ghost"
            icon={<InfoCircleOutlined />}
            onClick={openInfoDrawer}
          />
        </div>
      </div>
      <div
        style={{
          background: "var(--white)",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid var(--light-grey)"
        }}
      >
        <Form layout="inline" form={form}>
          {showGroupCodes && (
              <Form.Item name="groupCode" style={{ width: "300px" }}>
                <Select
                    // autoFocus={!selectedGroupCode}
                    ref={groupCodeRef}
                    placeholder="Group Code"
                    disabled={setSelectGroupCodeDisabled}
                    loading={!setSelectGroupCodeDisabled && groupCodes.length == 0}
                    onChange={onGroupCodeChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                            .toLowerCase()
                            .localeCompare(
                                (optionB!.label as unknown as string).toLowerCase()
                            )
                    }
                    options={groupCodes
                        .map((x: any) => ({
                          label: x.code,
                          value: x.code,
                          active: x.active,
                        }))
                        .sort(function (a, b) {
                          if (defaultGroupCode && b.value === defaultGroupCode) {
                            return 1;
                          }
                          if (!a.active && b.active) return 1;
                          if (a.active && !b.active) return -1;
                          if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                          if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                          return 0;
                        })}
                    filterOption={(inputValue, option) =>
                        option!.label
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    // filterSort={(optionA, optionB) =>
                    //     (optionA!.label as unknown as string)
                    //         .toLowerCase()
                    //         .localeCompare(
                    //             (optionB!.label as unknown as string).toLowerCase()
                    //         )
                    // }
                ></Select>
              </Form.Item>    
          )}
          {showEntities && (
              <Form.Item name="entity" style={{ width: "300px" }}>
                <Select
                    key={headEntities.map(x => x.id).join('-')}
                    ref={entityRef}
                    placeholder="Entity"
                    disabled={setSelectEntityDisabled}
                    loading={!setSelectEntityDisabled && headEntities.length == 0}
                    onChange={onEntityChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    options={filteredUniqueEntities.map((x: any) => ({
                      label: (
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span>{x.name}</span>
                            {showEntityCounts && (
                                <span style={{ marginLeft: "auto", color: "#d3d3d3" }}>
                              {entitySourceCounts.find(count => count.entityID === x.id)?.count ?? 0}
                            </span>
                            )}
                          </div>
                      ),
                      value: x.id,
                    }))}
                    filterOption={(inputValue, option) => {
                      const label = option!.label as unknown as JSX.Element;
                      const text = label.props.children[0].props.children;
                      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
                    }}
                    filterSort={(optionA, optionB) => {
                      const labelA = optionA!.label as unknown as JSX.Element;
                      const textA = labelA.props.children[0].props.children;

                      const labelB = optionB!.label as unknown as JSX.Element;
                      const textB = labelB.props.children[0].props.children;

                      return textA.toLowerCase().localeCompare(textB.toLowerCase())
                    }}
                />
              </Form.Item>
          )}
          {showOperations && (
              <Form.Item name="operation" style={{ width: "300px" }}>
                <Select
                    // autoFocus={selectedGroupCode && selectedEntity && !selectedOperation}
                    ref={operationRef}
                    placeholder="Operation"
                    disabled={setSelectOperationDisabled}
                    loading={!setSelectOperationDisabled && operations.length == 0}
                    onChange={onOperationsChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    options={operations
                        .filter((item: any) => item.name !== "Enrichment")
                        .map((x: any) => ({
                          label: (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>{x.label ?? x.name}</span>
                                {calculateMedallionTag(x.id)}
                              </div>
                          ),
                          value: x.id,
                          
                        }))}
                    filterOption={(inputValue, option) => {
                      const label = option!.label as unknown as JSX.Element;
                      const text = label.props.children[0].props.children;
                      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
                    }}
                ></Select>
              </Form.Item>  
          )}
          {showReports && (
              <Form.Item name="report" style={{ width: "300px" }}>
                <Select
                    // autoFocus={!selectedGroupCode}
                    ref={reportRef}
                    placeholder="Report"
                    loading={reports.length == 0}
                    onChange={onReportChange}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                            .toLowerCase()
                            .localeCompare(
                                (optionB!.label as unknown as string).toLowerCase()
                            )
                    }
                    options={reports
                        .map((x: any) => ({
                          label: x.name,
                          value: x.id,
                        }))
                        .sort(function (a, b) {
                          if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                          if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                          return 0;
                        })}
                    filterOption={(inputValue, option) =>
                        option!.label
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                    }
                ></Select>
              </Form.Item>
          )}
        </Form>
        {!setActionsDisabled && (
          <div className="backgroundActiveButton twofoldBtn">{mainAction}</div>
        )}
      </div>
      <Drawer
        width={"800px"}
        title={"Page instructions"}
        placement="right"
        closable={false}
        onClose={() => setShowWikiDrawer(false)}
        visible={showWikiDrawer}
        extra={
          <Space>
            <Button
              type="ghost"
              onClick={closeDrawer}
              icon={<CloseOutlined />}
              size="small"
            />
          </Space>
        }
      >
        <div dangerouslySetInnerHTML={{ __html: wikiContent }} />
      </Drawer>
    </div>
  );
};

export default PageHead;
